// need it to find size usages
export enum ItemIconSize {
    SIZE_12 = '12', // New For Asana
    SIZE_13 = '13',
    SIZE_14 = '14',
    SIZE_15 = '15',
    SIZE_16 = '16',
    SIZE_17 = '17',
    SIZE_18 = '18',
    SIZE_20 = '20',     // ???
    // SIZE_22     = '22',     // used in preview in project info
    SIZE_24 = '24',         // used in preview in project info
    SIZE_25 = '25',         // used in navbar more
    SIZE_27 = '27',         // used in quick add projects
}
